module.exports = __webpack_public_path__ + "static/img/serve1.b78efcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/serve1.png
// module id = HiX9
// module chunks = 1